import React, { useCallback, useEffect, useState } from "react";

import { Container } from "../../styles-components/Container";
import {
  Column,
  ErrorMessage,
  Form,
  FormHeader,
  Label,
  Row,
  RowValueButtons,
} from "../../styles-components/FormItens";
import { Button, OperationButton } from "../../styles-components/Buttons";
import { useForm } from "react-hook-form";
import inputFormat from "../../utils/inputFormat";
import { apiPedidosNutri } from "../../services/data";
import LoadingEffect from "../../components/LoadingEffect";
import { toast } from "react-toastify";
import UseRedirectView from "../../utils/UseRedirectView";
import DateVerifyValidate from "../../utils/DateVerifyValidate";
import { parseISO } from "date-fns";
import costCenters from "../../services/data/CostCenters";

const FormPedidosNutri = () => {

  const state = {
    orderTotal: 0
  }

  const [dataApi, setDataApi] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isSmallView, setIsSmallView] = useState(false);
  const [costCenters, setCostCenters] = useState([])

  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
    setValue,
    getValues,
    clearErrors,
    setError,
    unregister,
  } = useForm();

  const [watchTotal, watchService, watchTime] = watch([
    "total",
    "service_id",
    "time",
  ]);

  const fetchData = async () => {
    await apiPedidosNutri.index().then((response) => {
      response.data.data.services.sort(function (a, b) {
        return a.service.nome > b.service.nome
          ? 1
          : b.service.nome > a.service.nome
          ? -1
          : 0;
      });
      setDataApi(response.data.data);
    });
  };

  useEffect(() => {
    fetchData();
    if (window.innerWidth <= 570) {
      setIsSmallView(true);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (watchService !== "" && watchService !== undefined) {
      if (getValues("service_id") != 2) {
        unregister("coffee_litro_1");
        // unregister("coffee_litro_2");
      }
    }
  }, [watchService]);

  useEffect(() => {
    if (watchTime !== "" && watchTime !== undefined) {
      clearErrors("time");
      if (getValues("service_id") == 47) {
        var validation = DateVerifyValidate.handleAvailableDateEntry(
          parseISO(getValues("date")),
          parseInt(watchService),
          new Date(),
          watchTime
        );

        if (validation.error) {
          toast.error(validation.message, { toastId: validation.type });
          setError("time", { shouldFocus: true });
        }
      }
    }
  }, [watchTime]);

  const handleUpdateValueCoffee = useCallback(
    (coffee, operator) => {
      switch (operator) {
        case "+":
          setValue(coffee, parseInt(getValues(coffee)) + 1);
          break;

        case "-":
          setValue(coffee, parseInt(getValues(coffee)) - 1);
          break;
      }
    },
    [setValue, getValues]
  );

  const handleChangeSelectCliente =  (event) => {
    setCostCenters('');
    dataApi.clients.map((value, key) => {
      if (value.id === parseInt(event.target.value)) {
        setCostCenters([value]);
      }
    });
  };

  const handleFocus = (event) => {
    event.target.select();
  };


  const handleUpdateValueTotal = () =>(
    setValue('total', document.getElementById('total').value)
  );

  const handleUpdateTotolPerFactory = (e) =>{
    setValue(e.target.id, e.target.value)
  }


  const sunTotal = () => {
    let ammount = 0;
     costCenters[0].cost_centers.map((value, key) => {
      let inputValue = document.getElementById('empresa' + key).value;
      if (inputValue && !isNaN(inputValue)) {
        ammount += parseInt(inputValue);
        state.orderTotal = ammount;
      }
    })
    document.getElementById('total').value = state.orderTotal;
  }


  const onSubmit = useCallback(
    async (data) => {

      data.costCenters = {};
      data.is_especific = true;
      costCenters[0].cost_centers.map((value, key)=>{
          data.costCenters[key] = {
            'id' : value.id, 'quantity' : document.getElementById('empresa'+key).value
          };
      })

      console.log(data);

      await apiPedidosNutri
        .store(data)
        .then((response) => {
          if (response.data.data && response.data.data.error) {
            toast.error(response.data.data.message);
          } else {
            toast.success("Pedido cadastrado com sucesso!");
            UseRedirectView.to("nutri/pedidos/listagem");
          }
        })
        .catch((error) => toast.error(error.data.message));
    },
    [history,costCenters]
  );

  const handleSetValueButton = useCallback(
    (operator) => {
      switch (operator) {
        case "+":
          setValue("total", parseInt(watchTotal) + 1, { shouldValidate: true });
          break;

        case "-":
          setValue("total", parseInt(watchTotal) - 1, { shouldValidate: true });
          break;
      }
    },
    [watchTotal, setValue]
  );

  return (
    <>
      {isLoading ? (
        <LoadingEffect />
      ) : (
        <Container>
          <FormHeader>
            <h1>Cadastrar  pedidos</h1>
            <Button
              color="--white"
              backgroundColor="--orange"
              onClick={() => UseRedirectView.to("nutri/pedidos/listagem")}
            >
              Voltar
            </Button>
          </FormHeader>
          <Form method="POST" onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Label>Serviço</Label>
              <select
                {...register("service_id", {
                  required: {
                    value: true,
                    message: "Selecione um tipo de serviço",
                  },
                })}
                style={errors.service_id && { ...inputFormat }}
              >
                <option></option>
                {dataApi.services?.map((item) => (
                  <option key={item.service_id} value={item.service_id}>
                    {item.service.nome}
                  </option>
                ))}
              </select>
            </Row>
            {errors.service_id && (
              <ErrorMessage color="--red">
                {errors.service_id.message}
              </ErrorMessage>
            )}
            <Row>
              <Label>Cliente</Label>
              <select
                {...register("client_id", {
                  required: {
                    value: true,
                    message: "Selecione um cliente",
                  },
                })}
                style={errors.client_id && { ...inputFormat }}
                onChange={handleChangeSelectCliente}
              >
                <option value='0'></option>
                {dataApi.clients?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.razao_social}
                  </option>
                ))}
              </select>
            </Row>
            {errors.client_id && (
              <ErrorMessage color="--red">
                {errors.client_id.message}
              </ErrorMessage>
            )}
            <Row>
              <Label htmlFor="date">Data:</Label>
              <input
                type="date"
                {...register("date", {
                  required: { value: true, message: "Informe um data" },
                })}
                style={errors.date && { ...inputFormat }}
                id="date"
              />
            </Row>
            {errors.date && (
              <ErrorMessage color="--red">{errors.date.message}</ErrorMessage>
            )}
            {watchService == "47" && (
              <>
                <Row>
                  <Label htmlFor="horario">Horário:</Label>
                  <input
                    {...register("time", {
                      required: {
                        value: true,
                        message: "Informe um hórario",
                      },
                    })}
                    style={errors.time && { ...inputFormat }}
                    type="time"
                    id="horario"
                  />
                </Row>
                {errors?.time && (
                  <ErrorMessage color="--red">
                    {errors.time.message}
                  </ErrorMessage>
                )}
              </>
            )}
            {/*{watchService == "2" && (*/}
            {/*  <>*/}
            {/*    <Row>*/}
            {/*      <Label htmlFor="coffee_litro_1">Café Litro 1:</Label>*/}
            {/*      {!isSmallView ? (*/}
            {/*        <input*/}
            {/*          {...register("coffee_litro_1", {*/}
            {/*            value: 0,*/}
            {/*            required: {*/}
            {/*              value: true,*/}
            {/*              message: "Informe uma quantidade",*/}
            {/*            },*/}
            {/*            min: {*/}
            {/*              value: 1,*/}
            {/*              message: "Informe uma quantidade maior que 0",*/}
            {/*            },*/}
            {/*          })}*/}
            {/*          style={errors.e_litro_1 && { ...inputFormat }}*/}
            {/*          type="number"*/}
            {/*          id="coffee_litro_1"*/}
            {/*        />*/}
            {/*      ) : (*/}
            {/*        <RowValueButtons>*/}
            {/*          <OperationButton*/}
            {/*            type="button"*/}
            {/*            onClick={() =>*/}
            {/*              handleUpdateValueCoffee("coffee_litro_1", "-")*/}
            {/*            }*/}
            {/*          >*/}
            {/*            -*/}
            {/*          </OperationButton>*/}
            {/*          <input*/}
            {/*            {...register("coffee_litro_1", {*/}
            {/*              value: 0,*/}
            {/*              required: {*/}
            {/*                value: true,*/}
            {/*                message: "Informe uma quantidade",*/}
            {/*              },*/}
            {/*              min: {*/}
            {/*                value: 1,*/}
            {/*                message: "Informe uma quantidade maior que 0",*/}
            {/*              },*/}
            {/*            })}*/}
            {/*            style={errors.coffee_litro_1 && { ...inputFormat }}*/}
            {/*            type="number"*/}
            {/*            id="coffee_litro_1"*/}
            {/*          />*/}
            {/*          <OperationButton*/}
            {/*            type="button"*/}
            {/*            onClick={() =>*/}
            {/*              handleUpdateValueCoffee("coffee_litro_1", "+")*/}
            {/*            }*/}
            {/*          >*/}
            {/*            +*/}
            {/*          </OperationButton>*/}
            {/*        </RowValueButtons>*/}
            {/*      )}*/}
            {/*    </Row>*/}
            {/*    {errors?.coffee_litro_1 && (*/}
            {/*      <ErrorMessage color="--red">*/}
            {/*        {errors.coffee_litro_1.message}*/}
            {/*      </ErrorMessage>*/}
            {/*    )}*/}

            {/*  </>*/}
            {/*)}*/}

            {costCenters.length > 0 && (
              costCenters[0].cost_centers.map((value, key) =>(
                <Row key={key}>
                  <Label htmlFor={'empresa'+key}><p className='font-weight-bold'>{value.name}:</p></Label>
                  <input type="number"
                         id={'empresa'+key}
                         name={'empresa'+key}
                         key={key}
                         min="0"
                         {...register("empresa"+key,{
                           value : 0,
                           min: {
                             value : 0
                           }
                         })}
                         onFocus={handleFocus}
                         onBlur={sunTotal}
                         onChange= {e=>{ sunTotal(e); handleUpdateValueTotal(); handleUpdateTotolPerFactory(e)}}
                  />
                </Row>
              ))
            )}
              <>
                <Row>
                  <Label htmlFor="total">Total:</Label>
                  {
                    <input
                      type="number"
                      {...register("total", {
                        value: 0,
                        required: {
                          value: true,
                          message: "Informe um valor para este campo",
                        },
                        min: {
                          value: 1,
                          message: "Informe uma quantidade maior que 0",
                        },
                      })}
                      style={errors.total && { ...inputFormat }}
                      id="total"
                      readOnly={true}
                      className='form-control'
                    />
                  }
                </Row>
                {errors.total && (
                  <ErrorMessage color="--red">
                    {errors.total.message}
                  </ErrorMessage>
                )}
              </>

            <Column>
              <Label htmlFor="note">Observação:</Label>
              <textarea {...register("note")} id="note" cols="10"></textarea>
            </Column>
            <Button color="--white" backgroundColor="--orange" align="flex-end">
              Criar
            </Button>
          </Form>
        </Container>
      )}
    </>
  );
};

export default FormPedidosNutri;
